import { download, generateCsv, mkConfig } from "export-to-csv"
import { useDateTime } from "../../../../localization/useDateTime"
import { ParsedPaymentDetails } from "../supplierAcquiringReportsTypes"
import { useMoney } from "../../../../currency/useMoney"
import { useAppLocalization } from "../../../../localization/components/AppLocalizationProvider"
import { useCallback } from "react"
import { Dinero } from "dinero.js"

export function useExportAcquiringReportsBankTransfersDetailsToCsv(
    data: ParsedPaymentDetails[],
    startDate: string,
    endDate: string,
) {
    const dateTimeFactory = useDateTime()
    const moneyFactory = useMoney({ locale: "da-DK" })

    const { l10n } = useAppLocalization()

    const csvOptions = mkConfig({
        fieldSeparator: ";",
        quoteStrings: true,
        decimalSeparator: ",",
        useBom: true,
        useKeysAsHeaders: true,
        filename: `Facilitynet-reconciliation-bank-transfers-details-${startDate}_${endDate}`,
    })

    return useCallback(() => {
        function getAmountString(amount: Dinero<number> | undefined) {
            if (!amount) return ""
            return moneyFactory.formatAsNumber(amount)
        }

        function mapOrderToCsvRow(details: ParsedPaymentDetails) {
            return {
                "Order ID": details.orderId ?? "",
                "PSP Reference": details.pspPaymentReference ?? "",
                Booked: details.bookingDate
                    ? dateTimeFactory.formatDateTime(details.bookingDate)
                    : "",
                Available: details?.valueDate
                    ? dateTimeFactory.formatDate(details.valueDate)
                    : "",
                Gross: getAmountString(details.grossAmount),
                Fee: getAmountString(details.feeAmount),
                Net: getAmountString(details.netAmount),
            }
        }

        let exportRows: ReturnType<typeof mapOrderToCsvRow>[]

        if (data && data.length > 0) {
            exportRows = data.map((card) => mapOrderToCsvRow(card))
        } else {
            exportRows = [mapOrderToCsvRow({} as ParsedPaymentDetails)]
        }

        const csv = generateCsv(csvOptions)(exportRows)
        download(csvOptions)(csv)
    }, [dateTimeFactory, moneyFactory, data, startDate, endDate, l10n])
}
